module.exports = __webpack_public_path__ + "img/amazingSuggest.086bbaa5.svg";